export default __webpack_public_path__ + "static/media/single.be605839.jpg";